/**
 * @generated SignedSource<<e7d6a12e6b5d83f0d0ddcf3d12f45ab8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCoverPhotoNew_event$data = {
  readonly coverPhoto: {
    readonly transformUrl: string;
  } | null | undefined;
  readonly name: string;
  readonly prettyUrl: string;
  readonly updatedAt: string | null | undefined;
  readonly " $fragmentType": "EventCoverPhotoNew_event";
};
export type EventCoverPhotoNew_event$key = {
  readonly " $data"?: EventCoverPhotoNew_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCoverPhotoNew_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "dpr"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "imageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCoverPhotoNew_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "coverPhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "dpr",
                  "variableName": "dpr"
                },
                {
                  "kind": "Literal",
                  "name": "fit",
                  "value": "cover"
                },
                {
                  "kind": "Variable",
                  "name": "h",
                  "variableName": "imageSize"
                },
                {
                  "kind": "Variable",
                  "name": "w",
                  "variableName": "imageSize"
                }
              ],
              "kind": "ObjectValue",
              "name": "transform"
            }
          ],
          "kind": "ScalarField",
          "name": "transformUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "5f43932ed0e503dfd5724a604f1543bb";

export default node;
